import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import SearchView from "../../widgets/SearchView";
import ProofOfRegistrationSearchForm from './ProofOfRegistrationSearchForm';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";

const headCells = [
    { id: "Name", numeric: false, disablePadding: true, label: "Learner Name" },
    { id: "Surname", numeric: false, disablePadding: true, label: "Learner Surname" },
    { id: "Surname", numeric: false, disablePadding: true, label: "Learner Surname" },
    { id: "IDNumber", numeric: false, disablePadding: true, label: "Learner ID Number" },
    { id: "ProgrammeType", numeric: false, disablePadding: true, label: "Programme Type" },
    { id: "Programme", numeric: false, disablePadding: true, label: "Programme" },
]

const searchParameters = [
    { Name: "FinancialYearID", Value: "" },
    { Name: "LearningProgrammeID", Value: "" },
    { Name: "SocioEconomicStatusID", Value: "" },
    { Name: "RegistrationDateFrom", Value: "" },
    { Name: "RegistrationDateTo", Value: "" },
    { Name: "ProviderID", Value: "" },
    { Name: "EmployerID", Value: "" },
    { Name: "LearnershipName", Value: "" },
    { Name: "QualificationName", Value: "" },
    { Name: "SponsorshipID", Value: "" }
]

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const searchFormRef = React.createRef();

class LearnerDocuments extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                FinancialYearID: null,
                LearningProgrammeID: null,
                SocioEconomicStatusID: null,
                RegistrationDateFrom: null,
                RegistrationDateTo: null,
                ProviderID: null,
                EmployerID: null,
                LearnershipName: null,
                QualificationName: null,
                SponsorshipID: null
            },
            selectedLearners: null,
            keyUpSwitch: false,
            clearGrid: false,
            documentGenerated: false,
            documentName: null,
            messsageAlert: null,
            messageStyle: null,
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'generate', label: 'Generate', icon: 'CreateIcon', tooltip: 'Generate Letter', disabled: utils.isNull(this.state.selectedLearners) },
                        { id: 'email', label: 'Email', icon: 'EmailIcon', visible: false, tooltip: 'Email Letter', disabled: utils.isNull(this.state.selectedLearners) }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if ("generate" === buttonId) {
            this.generateLetter();
            toolbarRef.current.setButtonDisabled("generate", true);
            toolbarRef.current.setButtonDisabled("email", true);
        } else if ("email" === buttonId) {
            this.EmailLetter();
            toolbarRef.current.setButtonDisabled("generate", true);
            toolbarRef.current.setButtonDisabled("email", true);
        }
    }

    FileDownload = (documentName) => {

        utils.invokeUrl("api/sims/ProofOfRegistration/DownloadLetters?FileName=" + documentName, (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
            toolbarRef.current.setButtonDisabled("download", true);
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        }
        );

    };

    generateLetter = () => {
        const LearnerProgrammeIDs = this.state.selectedLearners.map(e => e.Id);
        let data = {
            IDs: LearnerProgrammeIDs,
            ...this.state.model
        }
        let url = "api/sims/ProofOfRegistration/GenerateLetters";
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            toolbarRef.current.setButtonDisabled("download", !this.state.documentGenerated);
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(data)
            }
        )
    };

    EmailLetter = () => {
        const LearnerProgrammeIDs = this.state.selectedLearners.map(e => e.Id);
        let data = {
            IDs: LearnerProgrammeIDs,
            ...this.state.model
        }
        let url = "api/sims/ProofOfRegistration/EmailLetters";
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(data)
            }
        )
    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedLearners: selection, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("generate", selection.length === 0);
                    toolbarRef.current.setButtonDisabled("email", selection.length === 0);
                }
            )
        } else {
            this.setState({ selectedLearners: null, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("generate", selection.length === 0);
                    toolbarRef.current.setButtonDisabled("email", selection.length === 0);
                }
            )
        }
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    handleFormValueChange = (values) => {
        let newValues = null;
        if (!utils.isNull(values)) {
            newValues = { ...values };
        }
        if (!utils.isNull(newValues)) {
            if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                /*if (!utils.isNull(newValues.FinancialYearID) && !utils.isNull(this.state.model.FinancialYearID) && newValues.FinancialYearID.Id !== this.state.model.FinancialYearID.Id) {
                    newValues.FinancialYearID = null;
                }
                if (!utils.isNull(newValues.LearningProgrammeID) && !utils.isNull(this.state.model.LearningProgrammeID) && newValues.LearningProgrammeID.Id !== this.state.model.LearningProgrammeID.Id) {
                    newValues.LearningProgrammeID = null;
                }*/
                this.setState({
                    model: newValues,
                    clearGrid: true,
                    selectedLearners: null,
                    Message: ""
                });
                toolbarRef.current.setButtonDisabled("generate", true);
                toolbarRef.current.setButtonDisabled("email", true);
            }
        }
    }

    onSearchRequiredFieldCheck = () => {
        if (searchFormRef.current.getValue()) {
            return true;
        }
        else {
            return false;
        }
    }

    onGridCleared = () => {
        this.setState({ clearGrid: false });
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <AlertItem
                    message={this.state.messsageAlert}
                    alertStyle={this.state.messageStyle}
                />
                <SearchView
                    headCells={headCells}
                    dataUrl="api/sims/ProofOfRegistration/GetSearch"
                    model={this.state.model}
                    toolbarConfig={this.toolbarConfig}
                    searchParameters={searchParameters}
                    searchLabel="SEARCH"
                    mode={this.props.mode}
                    multiSelect={true}
                    onLookupValueChange={this.props.onLookupValueChange}
                    history={this.props.history}
                    buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={(selection) => { this.handleSelectionChange(selection) }}
                    autoFetchData={false}
                    toolbarRef={toolbarRef}
                    onSearchRequiredFieldCheck={this.onSearchRequiredFieldCheck}
                    clearGrid={this.state.clearGrid}
                    onGridCleared={this.onGridCleared}
                    title={"Proof Of Registration"}
                >
                    <ProofOfRegistrationSearchForm
                        ref={searchFormRef}
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        model={this.state.model}
                        valueChangeHandler={this.handleFormValueChange}
                    //dependency={this.state.dependency}
                    />
                </SearchView>
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(LearnerDocuments)
);